import { gql } from '@web/federation/gql'

const FavoritesSectionQuery = gql(`
  query FavoritesSectionQuery {
   ...FavoritesSection_Query
  }
  fragment FavoritesSection_Query on Query {
    me  {
      ...on MeSucceed {
        ...FavoritesSection_Fragment
      }
    }
  }
  fragment FavoritesSection_Fragment on MeSucceed {
    frequentPlaces {
      id
      name
      alias
      address
      type
      distance
      shortcutType
      directionLandingUrl(appName: "m.place.naver.com/my") {
        car {
          appScheme
          webUrl
        }
      }
    }
  }

  fragment FavoritesSection_User on User {
    id
    idno
  }
`)

export default FavoritesSectionQuery
